

export const imageService = {
    // 錯誤訊息
    uploadFailed: '圖片上傳失敗',
    generateFailed: 'AI圖片生成失敗',
    editFailed: '圖片編輯失敗',
    getStatusFailed: '獲取生成狀態失敗',
    getHistoryFailed: '獲取生成歷史失敗',
    deleteRecordFailed: '刪除記錄失敗',
    downloadFailed: '下載失敗',
    downloadImageFailed: '下載圖片失敗',
    
    // 驗證訊息
    selectImageFile: '請選擇圖片檔案',
    unsupportedFormat: '只支援 JPG、PNG、WebP 格式的圖片',
    fileTooLarge: '圖片大小不能超過 10MB',
    imageUrlEmpty: '圖片URL不能為空',
    
    // 預設檔案名稱
    defaultFilename: 'generated-image.png'
  };
